import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Autocomplete,
    Box,
    Button,
    FormControlLabel,
    Grid,
    Paper,
    Radio,
    RadioGroup,
    TextField,
    Typography
} from '@mui/material';

import SubCard from 'ui-component/cards/SubCard';

// material-ui
import React, { useEffect, useState } from 'react';
// project imports
import ReusableList from 'ui-component/lhp-components/List';
import { Content, ListProps } from 'types/list';

import { getTableAsync } from 'service/bdr-service';
import getDevicesAsync, { getDeviceByIDAsync } from 'service/device-service';
import { AccordionResponse } from 'types/overrides/chart';

import { gridSpacing } from 'store/constant';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import CircularProgress from '@mui/material/CircularProgress';
import DeviceAccordion from 'ui-component/DeviceAccordion';

const BDR_TABLE = () => {
    const [customers, setCustomers] = useState<any[]>([]);
    const [tableTitle, setTableTitle] = useState<string>('');

    const [devices, setDevices] = useState<any[]>([]);

    const [expanded, setExpanded] = React.useState<boolean>(true);
    const [submitted, setSubmitted] = React.useState<boolean>(false);
    const [waitingForResponse, setWaitingForResponse] = React.useState<boolean>(false);

    const [content, setContent] = React.useState<ListProps>({
        title: 'BDR Table',
        content: { data: [], headers: [] },
        allowCSVExport: true
    });

    localStorage.setItem('currentPage', '/bdr-table');

    React.useEffect(() => {
        const fetchDropDowns = async () => {
            try {
                const devicesResponse = await getDevicesAsync();
                setDevices(devicesResponse);

                const customersResponse: Set<string> = new Set();
                devicesResponse.forEach((device: any) => {
                    // console.log(device.Customer, ' - ', device['Project Number'], ' - ', device['Vehicle ID']);
                    if (device.Customer !== null) {
                        customersResponse.add(device.Customer);
                    }
                });
                setCustomers(Array.from(customersResponse));
            } catch (error) {
                console.error('Error fetching user:', error);
            }
        };
        fetchDropDowns();
    }, []);

    const handleResponse = async (requestBody: AccordionResponse) => {
        setWaitingForResponse(true);
        setSubmitted(true);
        try {
            let foundDevices = new Map();
            // setleftAxisName(requestBody.leftAxisName);
            // setrightAxisName(requestBody.rightAxisName);
            // setRightVariables(requestBody.rightAxisVariables);

            //const SN = Array.isArray(requestBody.SNs) ? requestBody.SNs[0] : requestBody.SNs;

            const SN = requestBody.SNs;
            const response = await getTableAsync(
                requestBody.BDR_histogramTableName,
                SN,
                requestBody.BDR_VTBs,
                requestBody.BDR_SCUs,
                requestBody.startTimeStamp,
                requestBody.endTimeStamp
            );

            setTableTitle(requestBody.BDR_histogramTableName ?? '');

            let headers: string[] = [];

            if (response != 0) {
                headers = ['Customer', 'Project Number', 'Vehicle ID'];
                Object.keys(response[0]).forEach((key: any) => {
                    headers.push(key);
                });

                headers = headers.filter((item) => item != 'TransactionId' && item != 'id');

                /// RETREIVE PROJECT INFORMATION ////
                const device = await getDeviceByIDAsync({ SN: SN });

                for (let row of response) {
                    row.Customer = device.Customer;
                    row['Project Number'] = device['Project Number'];
                    row['Vehicle ID'] = device['Vehicle ID'];
                    row.TimeStampUTC = row.TimeStampUTC.replace('T', ' ');
                    row.TimeStampUTC = row.TimeStampUTC.replace('.000Z', '');
                }
                /////////////////////////////////////
            }

            //console.log(response);
            const contentResponse: Content = {
                data: response,
                headers: headers.map((header) => {
                    return {
                        title: header,
                        value: header
                    };
                })
            };

            setContent({
                title: response.length == 0 ? 'No data was found' : '',
                content: contentResponse,
                allowCSVExport: true
            });

            setWaitingForResponse(false);
        } catch (error) {
            console.error('Error submitting data:', error);
            setWaitingForResponse(false);
        }
    };

    return (
        <div>
            <DeviceAccordion parentCallback={handleResponse} selectedShowChart={false} UIType={'BDR'}></DeviceAccordion>
            <div>
                {waitingForResponse ? (
                    <Grid item lg={12} display={'flex'} alignItems={'center'} justifyContent={'center'} paddingTop={'5rem'}>
                        <Box key={'loadingBox'} sx={{ display: 'flex' }}>
                            <CircularProgress />
                        </Box>
                    </Grid>
                ) : (
                    <ReusableList
                        key={content?.content?.data.length}
                        title={tableTitle}
                        content={content.content}
                        allowCSVExport={true}
                    ></ReusableList>
                )}
            </div>
        </div>
    );
};

export default BDR_TABLE;
